import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ToastrService } from 'ngx-toastr';
import { ModalComponent } from 'src/app/common/modules/modal.module/modal/modal.component';
import { Consultation } from 'src/app/entities/consultation.entity';
import { TextFillings } from 'src/app/entities/text-fillings.entity/text-fillings';
import { User } from 'src/app/entities/user.entity';
import { Doctor } from 'src/app/entities/user.entity/doctor.entity';
import { DoctorAppointmentService } from 'src/app/services/doctor-appointments.service/doctor-appointments.service';
import { DoctorSecretaryAppointmentsService } from 'src/app/services/doctor-secretary-appointments.service/doctor-secretary-appointments.service';
import { TextFillingsService } from 'src/app/services/fillings.service/text-fillings.service';
import { SpeechService } from 'src/app/services/Speech.service/speech.service';

@Component({
  selector: 'app-consultation-reeducation',
  templateUrl: './consultation-reeducation.component.html',
  styleUrls: ['./consultation-reeducation.component.css']
})
export class ConsultationReeducationComponent implements OnInit {
usersList: any[] = [];
selectedUser: any;
@Input() consultation: Consultation = new Consultation();
@Input () doctor:any = new User() as Doctor;
@Output() consultationChange: EventEmitter<Consultation> = new EventEmitter();

  private baseTextBeforeListening: { [key: string]: string } = {};

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '60rem',
    minHeight: '0',
    maxHeight: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: '',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    sanitize: false,
  };

  open: boolean = false
  tableauTextFillings!: Array<TextFillings>
  questions: TextFillings | any = new TextFillings();

  @ViewChild(ModalComponent, { read: ModalComponent, static: false })
  dialog!: ModalComponent;

  constructor(
    private doctorAppointmentsService: DoctorAppointmentService,
    private textFillingsServices: TextFillingsService,
    private toastrService: ToastrService,
    private speechService: SpeechService
  ) { }

  ngOnInit(): void {
    this.getAssistants();
  }

  getAssistants() {
    this.doctorAppointmentsService.getAssistantList().subscribe({
      next: (res: any) => {
        const medecin = {
          ...res.medecin,
          type: 'DOCTOR'
        };

        const assistants = res.assistants.map((a: any) => ({
          ...a,
          type: 'ASSISTANT'
        }));

        this.usersList = [medecin, ...assistants];

        if (this.consultation?.consultationShare) {
          const foundUser = this.usersList.find(
            (u: any) => u.id === this.consultation.consultationShare
          );
          this.selectedUser = foundUser || medecin;
        } else {
          this.selectedUser = medecin;
          this.consultation.consultationShare = medecin.id;
        }

        this.consultationChange.emit(this.consultation);
      }
    });
  }
get canDictate(): boolean {
  return !!(this.doctor?.speechtoText || this.doctor?.doctor?.speechtoText);
}
  onUserChange() {
    if (!this.selectedUser) return;
    this.consultation.consultationShare = this.selectedUser.id;
    this.consultationChange.emit(this.consultation);
  }

  openDialoge(text: string): void {
    this.questions = this.tableauTextFillings.find(elm => elm.label == String(text))
    this.questions == undefined ? this.questions = new TextFillings({ label: text }) : "";
    this.dialog.open()
  }

  callUpdateQuestion(updateQuestion: TextFillings) {
    this.textFillingsServices.updateTextFillingsDoctor(String(updateQuestion.id), this.questions).subscribe(
      res => {
        this.toastrService.info('Mise a jour  Question')
        this.questions = res
        this.dialog.close()
      }
    )
  }

  callAddQuestion(question: TextFillings): void {
    this.questions = question
    this.textFillingsServices.addTextFillings(question).subscribe(
      res => {
        this.toastrService.success('Question Ajouter')
      }
    )
  }

  // ── Micro / dictée ──
  toggleMic(field: string) {
    if (!this.speechService.isListening) {
      this.baseTextBeforeListening[field] = (this.consultation as any)[field] || '';
    }

    this.speechService.toggle(
      field,
      (interimText: string) => {
        const base = this.baseTextBeforeListening[field] || '';
        (this.consultation as any)[field] = base ? base + ' ' + interimText : interimText;
      },
      (finalText: string) => {
        const base = this.baseTextBeforeListening[field] || '';
        const updated = base ? base + ' ' + finalText : finalText;
        (this.consultation as any)[field] = updated;
        this.baseTextBeforeListening[field] = updated;
        this.consultationChange.emit(this.consultation);
      }
    );
  }

  isMicActive(field: string): boolean {
    return this.speechService.isListening && this.speechService.activeField === field;
  }
}